import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Logo from './Logo';

const StyledFooter = styled.footer`
  background-color: var(--color-primary-dark);
  color: var(--color-light);
  padding: 4rem 0 2rem;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterHeading = styled.h4`
  color: var(--color-light);
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 0;
    width: 40px;
    height: 3px;
    background-color: var(--color-accent);
  }
`;

const FooterLink = styled(Link)`
  color: var(--color-gray);
  margin-bottom: 0.8rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--color-accent);
    transform: translateX(3px);
  }
`;

const ExternalLink = styled.a`
  color: var(--color-gray);
  margin-bottom: 0.8rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--color-accent);
  }
`;

const FooterText = styled.p`
  color: var(--color-gray);
  margin-bottom: 1rem;
  line-height: 1.6;
`;

const SocialIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialIcon = styled.a`
  color: var(--color-gray);
  margin-right: 1rem;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--color-accent);
    transform: translateY(-3px);
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--color-gray);
  font-size: 0.9rem;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <StyledFooter>
      <FooterContainer>
        <FooterColumn>
          <Logo />
          <FooterText style={{ marginTop: '1.5rem' }}>
            Architecting intelligent, scalable, and resilient technology solutions that bridge vision and execution.
          </FooterText>
          <SocialIcons>
            <SocialIcon href="#" aria-label="LinkedIn">
              <i className="fab fa-linkedin"></i>
            </SocialIcon>
            <SocialIcon href="#" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </SocialIcon>
            <SocialIcon href="#" aria-label="GitHub">
              <i className="fab fa-github"></i>
            </SocialIcon>
          </SocialIcons>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Quick Links</FooterHeading>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/about">About</FooterLink>
          <FooterLink to="/services">Services</FooterLink>
          <FooterLink to="/projects">Projects</FooterLink>
          <FooterLink to="/tech-stack">Tech Stack</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Services</FooterHeading>
          <FooterLink to="/services#architecture">Architecture</FooterLink>
          <FooterLink to="/services#consulting">Consulting</FooterLink>
          <FooterLink to="/services#system-design">System Design</FooterLink>
          <FooterLink to="/services#transformation">Transformation Strategy</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Contact</FooterHeading>
          <FooterText>
            <i className="fas fa-envelope" style={{ marginRight: '0.5rem' }}></i>
            info@kriegerlabs.net
          </FooterText>
          <FooterText>
            <i className="fas fa-map-marker-alt" style={{ marginRight: '0.5rem' }}></i>
            San Francisco, CA
          </FooterText>
          <ExternalLink 
            href="https://dev-84918634.okta.com/app/zendesk/exkt89ftiX6QbfOxz5d6/sso/saml"
            target="_blank"
            rel="noopener noreferrer"
          >
            SSO Sign In
          </ExternalLink>
        </FooterColumn>
      </FooterContainer>
      
      <Copyright>
        &copy; {currentYear} Kriegerlabs. All rights reserved.
      </Copyright>
    </StyledFooter>
  );
};

export default Footer;
